export default __webpack_public_path__ + "static/media/it-67.eb52f680.svg";